import { render } from "./GenealogyList.vue?vue&type=template&id=58cc6d49&scoped=true"
import script from "./GenealogyList.vue?vue&type=script&lang=js"
export * from "./GenealogyList.vue?vue&type=script&lang=js"

import "./GenealogyList.vue?vue&type=style&index=0&id=58cc6d49&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cc6d49"]])

export default __exports__